/**
 * An ask's act, taken where the ask is drawn, when the act needs nothing typed
 * (Notify and act §3.4: one RPC, no text, safe to repeat). Only the acts named
 * here are taken in one click; every other act opens its page.
 *
 *   complete_note — a note's reminder has come; Done (migration 1058).
 */
import { useState } from 'react';
import { getTypedSupabaseClient } from '@/lib/typedSupabaseClient';
import type { ResponsibilityCard } from '@/types/prioritization/responsibility';
import { quickActionOf } from '@/lib/responsibilityQuickAction';

export function CardQuickAction({ card, className = '', style, onDone }: {
  card: ResponsibilityCard;
  className?: string;
  style?: React.CSSProperties;
  onDone?: () => void;
}) {
  const action = quickActionOf(card);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (!action?.rpc) return null;
  return (
    <span className="inline-flex flex-col gap-1">
      <button
        type="button"
        disabled={busy}
        style={style}
        className={className || 'inline-flex items-center px-3 py-1.5 text-sm border border-[var(--rule)] hover:bg-[var(--hover-tint)]'}
        onClick={async () => {
          setBusy(true); setError(null);
          const { error: refused } = await getTypedSupabaseClient().rpc(
            action.rpc as 'complete_note',
            (action.args ?? {}) as { p_note_id: string },
          );
          setBusy(false);
          if (refused) { setError(refused.message); return; }
          onDone?.();
        }}
      >
        {busy ? '…' : action.label}
      </button>
      {error && <span className="text-xs text-[var(--coral)]">{error}</span>}
    </span>
  );
}
